export enum UserState {
    OrganisationCreator = 'OrganisationCreator',
    Invited = 'Invited',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    Blocked = 'Blocked'
}